import { render, staticRenderFns } from "./SettingsRange.vue?vue&type=template&id=3cc92864&"
import script from "./SettingsRange.vue?vue&type=script&lang=ts&"
export * from "./SettingsRange.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsRange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SettingsRange.vue"
export default component.exports